import type { PlainEnvironment } from "@/queries/environment-queries";
import { getRepoUrl } from "@/repo-url";

/**
 * Resolves the display name for an environment header.
 *
 * In environment-only mode (VS Code webview, no AI), the fallback chain is:
 *   branch → account/repo → environment name
 *
 * In normal mode:
 *   branch → account/repo → conversationName
 */
export function getEnvironmentDisplayName(
    environment: PlainEnvironment | undefined,
    conversationName: string,
    isAIEnabled: boolean,
): string {
    const branch = environment?.status?.content?.git?.branch;
    const repoInfo = environment ? getRepoUrl(environment) : undefined;
    const repoDisplay = repoInfo ? `${repoInfo.account}/${repoInfo.repo}` : undefined;

    const isEnvironmentOnly = !!window.isWebview && !isAIEnabled;
    if (isEnvironmentOnly) {
        return branch || repoDisplay || environment?.metadata?.name || conversationName;
    }

    return branch || repoDisplay || conversationName;
}
